// extracted by mini-css-extract-plugin
module.exports = {"searchTabs":"SearchTabs_searchTabs__YpCVo","searchTabs__tab":"SearchTabs_searchTabs__tab__jcIb2","searchTabs__tab--active":"SearchTabs_searchTabs__tab--active__uK04D"};